import "core-js/modules/es6.object.create";
import "core-js/modules/es6.weak-map";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.index-of";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.array.reduce";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import "core-js/modules/es6.function.name";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";

function _wrapRegExp(re, groups) { _wrapRegExp = function _wrapRegExp(re, groups) { return new BabelRegExp(re, undefined, groups); }; var _RegExp = _wrapNativeSuper(RegExp); var _super = RegExp.prototype; var _groups = new WeakMap(); function BabelRegExp(re, flags, groups) { var _this = _RegExp.call(this, re, flags); _groups.set(_this, groups || _groups.get(re)); return _this; } _inherits(BabelRegExp, _RegExp); BabelRegExp.prototype.exec = function (str) { var result = _super.exec.call(this, str); if (result) result.groups = buildGroups(result, this); return result; }; BabelRegExp.prototype[Symbol.replace] = function (str, substitution) { if (typeof substitution === "string") { var groups = _groups.get(this); return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) { return "$" + groups[name]; })); } else if (typeof substitution === "function") { var _this = this; return _super[Symbol.replace].call(this, str, function () { var args = []; args.push.apply(args, arguments); if (typeof args[args.length - 1] !== "object") { args.push(buildGroups(args, _this)); } return substitution.apply(this, args); }); } else { return _super[Symbol.replace].call(this, str, substitution); } }; function buildGroups(result, re) { var g = _groups.get(re); return Object.keys(g).reduce(function (groups, name) { groups[name] = result[g[name]]; return groups; }, Object.create(null)); } return _wrapRegExp.apply(this, arguments); }

import { enumHelper } from '@kontent-ai/core-sdk';
import { deliveryUrlHelper } from '../utilities';
import { ElementType } from '../elements';
export var ElementMapper =
/*#__PURE__*/
function () {
  function ElementMapper(config) {
    _classCallCheck(this, ElementMapper);

    this.config = config;
  }

  _createClass(ElementMapper, [{
    key: "mapElements",
    value: function mapElements(data) {
      // return processed item to avoid infinite recursion
      var processedItem = data.processedItems[data.dataToMap.item.system.codename];

      if (processedItem) {
        // item was already resolved
        return {
          item: processedItem,
          processedItems: data.processedItems,
          preparedItems: data.preparedItems,
          processingStartedForCodenames: data.processingStartedForCodenames
        };
      }

      var preparedItem = data.preparedItems[data.dataToMap.item.system.codename];
      var itemInstance = preparedItem === null || preparedItem === void 0 ? void 0 : preparedItem.item;

      if (!itemInstance) {
        // item is not present in response
        return undefined;
      } // mapp elements


      var elementCodenames = Object.getOwnPropertyNames(data.dataToMap.rawItem.elements);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = elementCodenames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var elementCodename = _step.value;
          var elementMap = this.resolveElementMap(itemInstance, elementCodename);
          var elementWrapper = {
            system: data.dataToMap.item.system,
            rawElement: data.dataToMap.rawItem.elements[elementCodename],
            element: elementMap.resolvedName
          };

          if (elementMap.shouldMapElement) {
            var mappedElement = this.mapElement({
              elementWrapper: elementWrapper,
              item: itemInstance,
              preparedItems: data.preparedItems,
              processingStartedForCodenames: data.processingStartedForCodenames,
              processedItems: data.processedItems
            }); // set mapped elements

            itemInstance.elements[elementMap.resolvedName] = mappedElement;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return {
        item: itemInstance,
        processedItems: data.processedItems,
        preparedItems: data.preparedItems,
        processingStartedForCodenames: data.processingStartedForCodenames
      };
    }
  }, {
    key: "mapElement",
    value: function mapElement(data) {
      var elementType = enumHelper.getEnumFromValue(ElementType, data.elementWrapper.rawElement.type);

      if (elementType) {
        if (elementType === ElementType.ModularContent) {
          return this.mapLinkedItemsElement({
            elementWrapper: data.elementWrapper,
            preparedItems: data.preparedItems,
            processingStartedForCodenames: data.processingStartedForCodenames,
            processedItems: data.processedItems
          });
        }

        if (elementType === ElementType.Text) {
          return this.mapTextElement(data.elementWrapper);
        }

        if (elementType === ElementType.Asset) {
          return this.mapAssetsElement(data.elementWrapper);
        }

        if (elementType === ElementType.Number) {
          return this.mapNumberElement(data.elementWrapper);
        }

        if (elementType === ElementType.MultipleChoice) {
          return this.mapMultipleChoiceElement(data.elementWrapper);
        }

        if (elementType === ElementType.DateTime) {
          return this.mapDateTimeElement(data.elementWrapper);
        }

        if (elementType === ElementType.RichText) {
          // add to parent items
          return this.mapRichTextElement(data.elementWrapper, data.processedItems, data.processingStartedForCodenames, data.preparedItems);
        }

        if (elementType === ElementType.UrlSlug) {
          return this.mapUrlSlugElement(data.elementWrapper);
        }

        if (elementType === ElementType.Taxonomy) {
          return this.mapTaxonomyElement(data.elementWrapper);
        }

        if (elementType === ElementType.Custom) {
          return this.mapCustomElement(data.elementWrapper);
        }
      }

      console.warn("Could not map element '".concat(data.elementWrapper.rawElement.name, "' of type '").concat(data.elementWrapper.rawElement.type, "'. Returning unknown element instead."));
      return this.mapUnknowElement(data.elementWrapper);
    }
  }, {
    key: "mapRichTextElement",
    value: function mapRichTextElement(elementWrapper, processedItems, processingStartedForCodenames, preparedItems) {
      var rawElement = elementWrapper.rawElement; // get all linked items and linked items codenames nested in rich text

      var richTextLinkedItems = [];
      var richTextLinkedItemsCodenames = []; // The Kontent Delivery API is not guaranteed to return rich-text modular_content array items in the same order in which they appear inside the `value` property.
      // We extract the modular_content codenames in the rich-text value and sort the raw modular_content based on that order instead.

      var rawModularContentCodenamesMatches = rawElement.value.matchAll(_wrapRegExp(/<object[\0-=\?-\uFFFF]+data\x2Dcodename="([0-9_a-z]*)".*?>/g, {
        codename: 1
      }));
      var rawModularContentCodenamesSorted = Array.from(rawModularContentCodenamesMatches).reduce(function (acc, match) {
        if (match.groups && match.groups.codename) {
          acc.push(match.groups.codename);
        }

        return acc;
      }, []);

      var rawModularContentCodenames = _toConsumableArray(rawElement.modular_content).sort(function (a, b) {
        return rawModularContentCodenamesSorted.indexOf(a) - rawModularContentCodenamesSorted.indexOf(b);
      });

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = rawModularContentCodenames[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var codename = _step2.value;
          richTextLinkedItemsCodenames.push(codename); // get linked item and check if it exists (it might not be included in response due to 'Depth' parameter)

          var preparedData = preparedItems[codename]; // first try to get existing item

          if (this.canMapLinkedItems()) {
            var existingLinkedItem = this.getOrSaveLinkedItemForElement(codename, rawElement, processedItems, processingStartedForCodenames, preparedItems);

            if (existingLinkedItem) {
              // item was found, add it to linked items
              richTextLinkedItems.push(existingLinkedItem);
            } else {
              // item was not found or not yet resolved
              if (preparedData) {
                var mappedLinkedItemResult = this.mapElements({
                  dataToMap: preparedData,
                  preparedItems: preparedItems,
                  processingStartedForCodenames: processingStartedForCodenames,
                  processedItems: processedItems
                }); // add mapped linked item to result

                if (mappedLinkedItemResult) {
                  richTextLinkedItems.push(mappedLinkedItemResult.item);
                }
              }
            }
          }
        } // get rich text images

      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
            _iterator2["return"]();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var richTextImagesResult = this.getRichTextImages(rawElement.images); // extract and map links & images

      var links = this.mapRichTextLinks(rawElement.links);
      var images = richTextImagesResult.richTextImages; // replace asset urls in html

      var richTextHtml = this.getRichTextHtml(rawElement.value, richTextImagesResult.imageUrlRecords);
      return {
        images: images,
        linkedItemCodenames: richTextLinkedItemsCodenames,
        linkedItems: richTextLinkedItems,
        links: links,
        name: rawElement.name,
        type: ElementType.RichText,
        value: richTextHtml
      };
    }
  }, {
    key: "mapDateTimeElement",
    value: function mapDateTimeElement(elementWrapper) {
      var _a;

      var rawElement = elementWrapper.rawElement;
      return Object.assign(Object.assign({}, this.buildElement(elementWrapper, ElementType.DateTime, function () {
        return rawElement.value;
      })), {
        displayTimeZone: (_a = rawElement.display_timezone) !== null && _a !== void 0 ? _a : null
      });
    }
  }, {
    key: "mapMultipleChoiceElement",
    value: function mapMultipleChoiceElement(elementWrapper) {
      return this.buildElement(elementWrapper, ElementType.MultipleChoice, function () {
        return elementWrapper.rawElement.value;
      });
    }
  }, {
    key: "mapNumberElement",
    value: function mapNumberElement(elementWrapper) {
      return this.buildElement(elementWrapper, ElementType.Number, function () {
        if (elementWrapper.rawElement.value === 0) {
          return 0;
        } else if (elementWrapper.rawElement.value) {
          return +elementWrapper.rawElement.value;
        }

        return null;
      });
    }
  }, {
    key: "mapTextElement",
    value: function mapTextElement(elementWrapper) {
      return this.buildElement(elementWrapper, ElementType.Text, function () {
        return elementWrapper.rawElement.value;
      });
    }
  }, {
    key: "mapAssetsElement",
    value: function mapAssetsElement(elementWrapper) {
      var _this2 = this;

      return this.buildElement(elementWrapper, ElementType.Asset, function () {
        var _a;

        var assetContracts = elementWrapper.rawElement.value;
        var assets = [];
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = assetContracts[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var assetContract = _step3.value;
            var renditions = null; // get asset url (custom domain may be configured)

            var assetUrl = _this2.config.assetsDomain ? deliveryUrlHelper.replaceAssetDomain(assetContract.url, _this2.config.assetsDomain) : assetContract.url;

            if (assetContract.renditions) {
              renditions = {};

              for (var _i = 0, _Object$keys = Object.keys(assetContract.renditions); _i < _Object$keys.length; _i++) {
                var renditionPresetKey = _Object$keys[_i];
                var rendition = assetContract.renditions[renditionPresetKey];
                renditions[renditionPresetKey] = Object.assign(Object.assign({}, rendition), {
                  url: "".concat(assetUrl, "?").concat(rendition.query) // enhance rendition with absolute url

                });
              }
            }

            var renditionToBeApplied = _this2.config.defaultRenditionPreset && (renditions === null || renditions === void 0 ? void 0 : renditions[_this2.config.defaultRenditionPreset]) || null;
            var finalUrl = (_a = renditionToBeApplied === null || renditionToBeApplied === void 0 ? void 0 : renditionToBeApplied.url) !== null && _a !== void 0 ? _a : assetUrl;
            var asset = Object.assign(Object.assign({}, assetContract), {
              url: finalUrl,
              // use custom url of asset which may contain custom domain and applied rendition
              renditions: renditions
            });
            assets.push(asset);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
              _iterator3["return"]();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        return assets;
      });
    }
  }, {
    key: "mapTaxonomyElement",
    value: function mapTaxonomyElement(elementWrapper) {
      var _a;

      return Object.assign(Object.assign({}, this.buildElement(elementWrapper, ElementType.Taxonomy, function () {
        return elementWrapper.rawElement.value;
      })), {
        taxonomyGroup: (_a = elementWrapper.rawElement.taxonomy_group) !== null && _a !== void 0 ? _a : null
      });
    }
  }, {
    key: "mapUnknowElement",
    value: function mapUnknowElement(elementWrapper) {
      return this.buildElement(elementWrapper, ElementType.Unknown, function () {
        return elementWrapper.rawElement.value;
      });
    }
  }, {
    key: "mapCustomElement",
    value: function mapCustomElement(elementWrapper) {
      // try to find element resolver
      if (this.config.elementResolver) {
        var elementResolverValue = this.config.elementResolver(elementWrapper);

        if (elementResolverValue) {
          return this.buildElement(elementWrapper, ElementType.Custom, function () {
            return elementResolverValue;
          });
        }
      }

      return this.buildElement(elementWrapper, ElementType.Custom, function () {
        return elementWrapper.rawElement.value;
      });
    }
  }, {
    key: "mapUrlSlugElement",
    value: function mapUrlSlugElement(elementWrapper) {
      return this.buildElement(elementWrapper, ElementType.UrlSlug, function () {
        return elementWrapper.rawElement.value;
      });
    }
  }, {
    key: "mapLinkedItemsElement",
    value: function mapLinkedItemsElement(data) {
      // prepare linked items
      var linkedItems = []; // value = array of item codenames

      var linkedItemCodenames = data.elementWrapper.rawElement.value;
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = linkedItemCodenames[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var codename = _step4.value;

          if (this.canMapLinkedItems()) {
            var linkedItem = this.getOrSaveLinkedItemForElement(codename, data.elementWrapper.rawElement, data.processedItems, data.processingStartedForCodenames, data.preparedItems);

            if (linkedItem) {
              // add item to result
              linkedItems.push(linkedItem);
            }
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4["return"] != null) {
            _iterator4["return"]();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return Object.assign(Object.assign({}, this.buildElement(data.elementWrapper, ElementType.ModularContent, function () {
        return linkedItemCodenames;
      })), {
        linkedItems: linkedItems
      });
    }
  }, {
    key: "getOrSaveLinkedItemForElement",
    value: function getOrSaveLinkedItemForElement(codename, element, processedItems, mappingStartedForCodenames, preparedItems) {
      // first check if item was already resolved and return it if it was
      var processedItem = processedItems[codename];

      if (processedItem) {
        // item was already resolved
        return processedItem;
      }

      var preparedItem = preparedItems[codename];

      if (mappingStartedForCodenames.includes(codename)) {
        return preparedItem === null || preparedItem === void 0 ? void 0 : preparedItem.item;
      }

      mappingStartedForCodenames.push(codename); // throw error if item is not in response and errors are not skipped

      if (!preparedItem) {
        return undefined;
      }

      var mappedLinkedItem; // original resolving if item is still undefined

      var mappedLinkedItemResult = this.mapElements({
        dataToMap: preparedItem,
        preparedItems: preparedItems,
        processingStartedForCodenames: mappingStartedForCodenames,
        processedItems: processedItems
      });

      if (mappedLinkedItemResult) {
        mappedLinkedItem = mappedLinkedItemResult.item; // add to processed items

        processedItems[codename] = mappedLinkedItem;
      }

      return mappedLinkedItem;
    }
  }, {
    key: "mapRichTextLinks",
    value: function mapRichTextLinks(linksJson) {
      var links = [];

      for (var _i2 = 0, _Object$keys2 = Object.keys(linksJson); _i2 < _Object$keys2.length; _i2++) {
        var linkId = _Object$keys2[_i2];
        var linkRaw = linksJson[linkId];
        links.push({
          codename: linkRaw.codename,
          linkId: linkId,
          urlSlug: linkRaw.url_slug,
          type: linkRaw.type
        });
      }

      return links;
    }
  }, {
    key: "getRichTextHtml",
    value: function getRichTextHtml(richTextHtml, richTextImageRecords) {
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = richTextImageRecords[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var richTextImageRecord = _step5.value;

          // replace rich text image url if it differs
          if (richTextImageRecord.newUrl !== richTextImageRecord.originalUrl) {
            richTextHtml = richTextHtml.replace(new RegExp(richTextImageRecord.originalUrl, 'g'), richTextImageRecord.newUrl);
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5["return"] != null) {
            _iterator5["return"]();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return richTextHtml;
    }
  }, {
    key: "getRichTextImages",
    value: function getRichTextImages(imagesJson) {
      var _a, _b, _c;

      var images = [];
      var imageUrlRecords = [];

      for (var _i3 = 0, _Object$keys3 = Object.keys(imagesJson); _i3 < _Object$keys3.length; _i3++) {
        var imageId = _Object$keys3[_i3];
        var imageRaw = imagesJson[imageId]; // image may contain custom asset domain

        var imageUrl = this.config.assetsDomain ? deliveryUrlHelper.replaceAssetDomain(imageRaw.url, this.config.assetsDomain) : imageRaw.url;
        images.push({
          description: (_a = imageRaw.description) !== null && _a !== void 0 ? _a : null,
          imageId: imageRaw.image_id,
          url: imageUrl,
          height: (_b = imageRaw.height) !== null && _b !== void 0 ? _b : null,
          width: (_c = imageRaw.width) !== null && _c !== void 0 ? _c : null
        });
        imageUrlRecords.push({
          originalUrl: imageRaw.url,
          newUrl: imageUrl
        });
      }

      return {
        imageUrlRecords: imageUrlRecords,
        richTextImages: images
      };
    }
  }, {
    key: "resolveElementMap",
    value: function resolveElementMap(item, originalElementCodename) {
      var resolvedElementPropertyName = undefined;

      if (this.config.propertyNameResolver) {
        resolvedElementPropertyName = this.config.propertyNameResolver(item.system.type, originalElementCodename);
      }

      if (!resolvedElementPropertyName) {
        // use original element codename
        resolvedElementPropertyName = originalElementCodename;
      }

      return {
        resolvedName: resolvedElementPropertyName,
        shouldMapElement: true
      };
    }
  }, {
    key: "buildElement",
    value: function buildElement(elementWrapper, type, valueFactory) {
      return {
        name: elementWrapper.rawElement.name,
        type: type,
        value: valueFactory()
      };
    }
  }, {
    key: "canMapLinkedItems",
    value: function canMapLinkedItems() {
      if (!this.config.linkedItemsReferenceHandler) {
        return true;
      }

      return this.config.linkedItemsReferenceHandler === 'map';
    }
  }]);

  return ElementMapper;
}();